import {IApplication} from "../interfaces/application";

let appSingleton: IApplication;

export function storeAppSingleton(theApp: IApplication): void {

    if (appSingleton) {
        throw Error("Error - attempting to reinitialize the global app.");
    }
    appSingleton = theApp;
}

export function app(): IApplication {

    return appSingleton;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--7!./src/script/common/global.ts